/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_FutarokuInputs */

const ja_home_brands_futaroku = /** @type {(inputs: Home_Brands_FutarokuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Futaroku`)
};

const en_home_brands_futaroku = /** @type {(inputs: Home_Brands_FutarokuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Futaroku`)
};

/**
* | output |
* | --- |
* | "Futaroku" |
*
* @param {Home_Brands_FutarokuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_futaroku = /** @type {((inputs?: Home_Brands_FutarokuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_FutarokuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_futaroku(inputs)
	return en_home_brands_futaroku(inputs)
});